
import { Button, Tooltip } from '@mui/material';
import React, { useEffect,useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import BDC from '../../../Components/Docs/bdc';
import { buttonStyles } from '../../../Components/docsAdministrative/JsObjectStyles';
import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import { dureeBdcEnum, StatutsMisionEnum } from '../../../data/Interfaces';
//import { defaultMaterialTheme, materialTableOptions, ,  } from '../../../Components/shared/MuiSharedElements';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useIsExpertEsn from '../../../hooks/useIsExpertEsn';
// import useColumnVisibility from '../../../hooks/useColumnVisibility';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { getNomPrenomClearFromPersoData, getStatutMissionEnCoursSiDateDebutPasEncoreCommencee, searchLabelInEnumByValue, statutBdc, visibilityBdc } from '../../../Utils/utils';
import { getMontatantTTC } from '../../../Utils/utilsCraX';
// const styleMissionTable = { border: '1px solid #000' };
const AllExpertMissions = () => {
    const { addEuro4Decimal } = useNumberFormatting();

    const [missions, setMissions] = useState([]);
    const axiosPrivate = useAxiosPrivate();
    const [missionsData, setMissionsData] = useState([]);
    const role=useRole();
    const [selectedMission, setSelectedMission] = useState();
    const [openBdc, setOpenBdc] = useState(false);
    const { setBackdropOpen } = useUtilities();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [url, setUrl] = useState('');
    const { i18n } = useTranslation();
    const [filtreMissionEncours, setFiltreMissionEncours] = useState(searchParams.get('filtreMissionEncours') === 'true');
    const [filtreMissionTermine, setFiltreMissionTermine] = useState(searchParams.get('filtreMissionTermine') === 'true');
    const isEsnExpert=useIsExpertEsn();
    const columns= [
        {
            field: 'missionId',
            title: i18n.t('Réf.mission'),
            // cellStyle: { minWidth: 118, maxWidth: 118 },
            // hiddenByColumnsButton: true,
        },
        {
            field: 'companyId',
            title: i18n.t('Réf.Client'),
            // cellStyle: { minWidth: 118, maxWidth: 118 },
            // hiddenByColumnsButton: true,
        },
        {
            field: 'nomClient',
            title: i18n.t('Nom du client'),
            // cellStyle: { minWidth: 118, maxWidth: 118 },
            // hiddenByColumnsButton: true,
        },
        ...(role=='esn' ?
            [{
                field: 'nomExpert',
                title: i18n.t('Nom Expert'),
            }]:[]),
        {
            field: 'statutMission',
            title: i18n.t('Statut mission'),
            // cellStyle: { minWidth: 118, maxWidth: 118 },
            render: rowData =>
                i18n.t(getStatutMissionEnCoursSiDateDebutPasEncoreCommencee(
                    i18n.t(searchLabelInEnumByValue(StatutsMisionEnum, (rowData?.statutMission))),
                    rowData?.dateDebutMission,
                // rowData?.isInterruptionEnCours
                )),
            // hiddenByColumnsButton: true,
        // hidden: getColumnHiddenState(columnVisibilityState,'statutMission'),
        },
        {
            field: 'titre',
            title: i18n.t('Intitulé de la mission'),
            // cellStyle: { minWidth: 118, maxWidth: 118 },
            // hiddenByColumnsButton: true,
        },
        {
            field: 'dateDebutMission',
            title: i18n.t('Date début mission'),
            // cellStyle: { minWidth: 118, maxWidth: 118 },
            // hiddenByColumnsButton: true,
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.dateDebutMission),
        },
        {
            field: 'dateFinMission',
            title: i18n.t('Date fin mission'),
            // cellStyle: { minWidth: 118, maxWidth: 118 },
            // hiddenByColumnsButton: true,
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.dateFinMission),
        },
        {
            field: 'refBdc',
            title: i18n.t('Réf.BDC/Expert'),
            // cellStyle: { minWidth: 118, maxWidth: 118 },
            // hiddenByColumnsButton: true,
            render:  rowData => (
                <Button
                    variant='text'
                    style={{...buttonStyles(),...{color: visibilityBdc(rowData?.statutOrdreMission, rowData?.statutPropositionCommerciale, rowData?.statutMission) ? '#9BA6E7':'#214DCE' }}}
                    onClick={()=> {
                        setSelectedMission(rowData);
                        handleClickOpen();
                    }}
                    disabled={(visibilityBdc(rowData?.statutOrdreMission, rowData?.statutPropositionCommerciale, rowData?.statutMission) || rowData?.isExpertEsn)}
                >
                    {rowData?.refBdc + 'E'}
                </Button>
            ),

        // hidden: getColumnHiddenState(columnVisibilityState,'refBdc'),
        },
        {
            field: 'statutBdc',
            title: i18n.t('Statut BDC'),
            render: rowData =>
                i18n.t(rowData?.statutBdc)
            // cellStyle: { minWidth: 118, maxWidth: 118 },
            // hiddenByColumnsButton: true,
        },
        {
            field: 'dateDebBdc',
            title: i18n.t('Date début BDC'),
            // cellStyle: { minWidth: 118, maxWidth: 118 },
            // hiddenByColumnsButton: true,
            render: rowData =>
                formatDateJJMMYYYY(rowData?.dateDebBdc),

        // hidden: getColumnHiddenState(columnVisibilityState,'dateDebBdc'),
        },
        {
            field: 'dateFinBdc',
            title: i18n.t('Date fin BDC'),
            // cellStyle: { minWidth: 118, maxWidth: 118 },
            // hiddenByColumnsButton: true,
            render: rowData =>
                formatDateJJMMYYYY(rowData?.dateFinBdc),

        // hidden: getColumnHiddenState(columnVisibilityState,'dateFinBdc'),
        },
        {
            field: 'nbJoursBDC',
            title: i18n.t('Nb de jours BDC'),
            // cellStyle: { minWidth: 118, maxWidth: 118 },
            // hiddenByColumnsButton: true,
            render: (rowData) => {
                return addEuro4Decimal(rowData?.nbJoursBDC,'j');
            },

        // hidden: getColumnHiddenState(columnVisibilityState,'nbJoursBDC'),
        },
        {
            field: 'frequenceRenouvelement',
            title: i18n.t('Fréq.de renouvellement'),
            // cellStyle: { minWidth: 118, maxWidth: 118 },
            // hiddenByColumnsButton: true,
            render:  rowData =>
                i18n.t(searchLabelInEnumByValue(dureeBdcEnum,rowData?.frequenceRenouvelement)),
        // hidden: getColumnHiddenState(columnVisibilityState,'frequenceRenouvelement'),
        },
        ...(!isEsnExpert?
            [{
                field: 'tjExpertHt',
                title: i18n.t('Taux journalier HT'),
                render:  rowData =>
                    rowData?.isExpertEsn ? '--' : addEuro4Decimal(rowData?.tjExpertHt),
            // hidden: getColumnHiddenState(columnVisibilityState,'tjExpertHt'),
            },
            {
                field: 'tjExpertTTC',
                title: i18n.t('Taux journalier TTC'),
                // cellStyle: { minWidth: 118, maxWidth: 118 },
                // hiddenByColumnsButton: true,
                render:  rowData =>
                    rowData?.isExpertEsn ? '--' : addEuro4Decimal(rowData?.tjExpertTTC),
            // hidden: getColumnHiddenState(columnVisibilityState,'tjExpertTTC'),
            }]:[]),
        {
            field: 'responsableOperationnel',
            title: i18n.t('Resp.opérationnel'),
            // cellStyle: { minWidth: 118, maxWidth: 118 },
            // hiddenByColumnsButton: true,
        // hidden: getColumnHiddenState(columnVisibilityState,'responsableOperationnel'),
        },
        {
            field: 'chargeRecrutement',
            title: i18n.t('Chargé de recrutement'),
            // cellStyle: { minWidth: 118, maxWidth: 118 },
            // hiddenByColumnsButton: true,
        // hidden: getColumnHiddenState(columnVisibilityState,'chargeRecrutement'),
        },
        ...(role==='esn' ?
            [{
                field: 'commercial',
                title: i18n.t('Commercial'),
            }]:[]),
        {
            field: 'motifInterruption',
            title: i18n.t('Motif d\'interruption'),
            // cellStyle: { minWidth: 118, maxWidth: 118 },
            // hiddenByColumnsButton: true,
            render: rowData => {
                return (
                    <Tooltip title={rowData.dateEffective ? formatDateJJMMYYYY(rowData.dateEffective) :''}>
                        <p style={{margin:'0px'}}>{rowData.motifInterruption}</p>
                    </Tooltip>
                );
            },
        // hidden: getColumnHiddenState(columnVisibilityState,'motifInterruption'),
        },
    ];

    // const { columns, handleColumnHiddenChange } = useColumnVisibility('allExpertMissionsColumns', initialColumns);
    useEffect(() => {
        const currentUrl = window.location.href;
        setUrl(currentUrl);
    }, [location]);

    useEffect(() => {
        if(url && !url.toLowerCase().includes('filtremissiontermine') && !url.toLowerCase().includes('filtremissionencours') ){
            setFiltreMissionEncours(false);
            setFiltreMissionTermine(false);
            getMissions();
        }
    }, [url]);

    useEffect(() => {
        if(role)
            getMissions();
    }, [filtreMissionTermine,filtreMissionEncours,role]);

    const handleClickOpen = async () => {
        setOpenBdc(true);
    };

    const handleClose = () => {
        setOpenBdc(false);
        getMissions();
    };

    useEffect(() => {
        if(role)
            getMissions();
    },[role]);

    const mapBDC = (mission,bdc,isLastBDC) => {
        return {
            'missionId': mission?.missionId,
            'companyId': mission?.companyDataId?.clientId ?? mission?.esnId?.esnId ,
            'nomClient': getNomPrenomClearFromPersoData(mission?.companyDataId?.profileEntreprise ?? mission?.esnId?.profileEntreprise),
            'statutMission': mission?.statutMission,
            'titre': mission?.titre,
            'isExpertEsn':(role=='expert' && mission?.esnExpertOwnerId) ? true :false,
            'id':mission?._id,
            'createdAt': formatDateJJMMYYYY(mission?.createdAt),
            'BDCs':bdc,
            'dateDebutMission': mission?.dateDebutMission,
            'dateFinMission': mission?.dateFinMission,
            'refBdc':bdc?.bdcId,
            'dateDebBdc': bdc?.dateDebutBDC,
            'nomExpert': getNomPrenomClearFromPersoData(mission?.expertId?.persoData),
            'dateFinBdc': bdc?.dateFinBDC,
            'nbJoursBDC':bdc?.nbJoursBDC,
            'statutOrdreMission':mission?.ordreDeMission?.statut,
            'statutPropositionCommerciale':mission?.propositionCommerciale?.statut,
            'frequenceRenouvelement': bdc?.frequenceRenouv,
            'statutBdc': statutBdc(
                mission?.ordreDeMission?.statut,
                mission?.propositionCommerciale?.statut,
                mission?.statutMission,
                isLastBDC
            ),
            'tjExpertHt': bdc?.tj,
            'expertId':mission?.expertId,
            //PS: Ajouter TVA
            'tjExpertTTC':getMontatantTTC(bdc.tj, (bdc?.tauxTvaExpert ?? mission?.expertId?.entreprise?.tauxTva ?? mission?.esnExpertOwnerId?.donneeFacturation?.tauxTva)),
            //'tjExpertTTC':getMontatantTTC(bdc.tjClient, mission?.companyDataId?.donneeFacturation?.tauxTva),
            // 'motifInterruption':  mission?.interruptionExpert?.isInterrupted ? mission?.interruptionExpert?.motifInterruption : '',
            'motifInterruption': mission?.interruptionBackOffice?.wasAccepted == true ? mission?.interruptionBackOffice?.motifAcceptation ?? '' : '', //?? mission?.interruptionBackOffice?.motifRejet
            'dateEffective': mission?.interruptionBackOffice?.wasAccepted == true ? mission?.interruptionBackOffice?.dateEffective ?? '' : '',
            'interruptionExpert': mission?.interruptionExpert,
            'interruptionClient': mission?.interruptionClient,
            'interruptionBackOffice':mission?.interruptionBackOffice,
            'chargeRecrutement': getNomPrenomClearFromPersoData(bdc?.backOfficeId?.persoData),
            'responsableOperationnel': getNomPrenomClearFromPersoData(bdc?.responsableOperationnelId?.persoData ??bdc?.responsableOperationnelEsnId?.persoData  ),
            'commercial':getNomPrenomClearFromPersoData(bdc?.collaboratorEsnExpertId?.persoData),
            'companyDataId':mission?.companyDataId,
            'esnId':mission?.esnId,
            'esnExpertOwnerId':mission?.esnExpertOwnerId,
            // * l interruption est-il traiter ou pas , mais sans aucun info sur la dateEffective s'est passee ou pas encore, donc on a cree le statut intermidiare dans le backend [BD] dirrectement
            // isInterruptionTraited: (mission?.interruptionBackOffice?.wasAccepted == true ||
            //     mission?.interruptionBackOffice?.wasAccepted == false) &&
            //     (!mission?.interruptionClient?.isInterrupted && !mission?.interruptionExpert?.isInterrupted),
            // * isInterruptionEnCours =  encours de demande
            // isInterruptionEnCours: mission?.interruptionClient?.isInterrupted || mission?.interruptionExpert?.isInterrupted,

        };
    };
    useEffect(() => {
        if (missions) {
            let newData=[];
            // console.log({missions});
            if(filtreMissionEncours==true){
                missions.reverse().forEach(mission => {
                    if(mission?.statutMission=='encours' || mission?.statutMission=='interruptionEnCours'){
                        mission.BDCs.forEach((bdc, index) => {
                            // console.log('mission mission',mission);
                            let isLastBDC = mission.BDCs.length == index + 1;
                            newData.push(mapBDC(mission,bdc,isLastBDC));
                        });
                    }
                });
            }
            else if (filtreMissionTermine==true){
                missions.reverse().forEach(mission => {
                    if(mission?.statutMission=='terminee' || mission?.statutMission=='interompu'){
                        mission.BDCs.forEach((bdc, index) => {
                            // console.log('mission mission',mission);
                            let isLastBDC = mission.BDCs.length == index + 1;
                            newData.push(mapBDC(mission,bdc,isLastBDC));
                        });
                    }
                });
            }
            else {
                missions.reverse().forEach(mission => {
                    mission.BDCs.forEach((bdc, index) => {
                        // console.log('mission mission',mission);
                        let isLastBDC = mission.BDCs.length == index + 1;
                        newData.push(mapBDC(mission,bdc,isLastBDC));
                    });
                });
            }
            setMissionsData(newData);
        }
    }, [missions]);

    const getMissions = async () => {
        try {
            setBackdropOpen(true);
            // console.log('HELLO FROM the get Missions useEffect');
            const response = await axiosPrivate.get(`/mission/getMissions${role === 'esn' ? '?isAchat=false' : ''}`, {
                // signal: controller.signal
            });
            // console.log(response.data);
            setMissions(response.data);
            setBackdropOpen(false);
        } catch (error) {
            console.log(error);
            setBackdropOpen(false);
        }
    };

    const [selectedRow, setSelectedRow] = React.useState(null);

    return (
        <>

            {role === 'esn'
                ? (
                    <div className='frame5Profile'>
                        {i18n.t('Gestion des missions-HTH')}
                        &gt;
                        <span style={{ color: '#B0B0B0' }}>{i18n.t('Vente')}</span>
                        &gt;
                        <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Missions')}</span>
                    </div>
                )
                : (
                    <div className='frame5Profile'>
                        {i18n.t('Missions et BDC')}
                        &gt;
                        <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Missions')}</span>
                    </div>
                )
            }

            <div className='HomeFrame'>
                <div className='HomeFrameTitle'>
                    <h1 className='TitleHStyle'> {i18n.t('Missions et BDC')}</h1>
                </div>
                <MaterialTableComponent
                    columns={columns}
                    data={missionsData}
                    title={i18n.t('Missions et BDC')}
                    onRowClick={(event, rowData) => {
                        setSelectedRow(rowData?.tableData.id);
                        //setSelectedMission(rowData);
                        //    console.log(rowData);
                        //    console.log(open);
                        //handleClickOpen();
                    }}
                    option= {{
                        columnsButton: true,
                    }}
                    // onChangeColumnHidden={(orderedColumnId, orderDirection) => {
                    //     handleColumnVisibilityChange(columns[orderedColumnId?.tableData?.id].field, orderDirection !== 'desc');
                    // }}
                    selectedRow={selectedRow}
                />

            </div>
            {openBdc &&
            <BDC
                handleClose={handleClose}
                mission={selectedMission}
                open={openBdc}
                role={'expert'}
            />}
        </>
    );
};

export default AllExpertMissions;